export class FIPSState {
  Id?: number;
  RecordId?: number;
  Name: string;
  Number: string;
  ENS: string;
  RequiresRestBreak: boolean;
  TimeRoundToMinutes: boolean;
  IsDeleted: boolean;

  constructor(obj?: Partial<FIPSState>) {
    if (obj) {
      Object.assign(this, obj);
    } else {
      throw Error('Object cannot be null');
    }
  }

  isSoftDeleted(): boolean {
    return this.IsDeleted;
  }
}
